import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import classnames from "classnames";

import getDate from "date-fns/getDate";

import "./DatePicker.css";

import Col from "../../uiElements/grid/Col";
import DateTimeIcon from "../../uiElements/icons/onboardingIcons/DateTimeIcon";

const BorderMultiSelect = ({
  value,
  onChange,
  startDate,
  endDate,
  className,
  renderDayContents,
  customInput,
}) => {
  const renderDayContent = (day, date) => {
    return (
      <>
        <span>{getDate(date)}</span>
      </>
    );
  };

  const CustomInput = React.forwardRef((props, ref) => {
    return (
      <div
        onClick={props.onClick}
        className="row label-row"
        style={{
          borderRadius: 40,
        }}
      >
        <Col className="mt-2">
          <label className="datepicker-label">{value}</label>
        </Col>
        <Col className="mt-n5 mb-2">
          <div style={{ marginTop: 5, marginLeft: "92%" }}>
            <DateTimeIcon type="calenderButton" />
          </div>
        </Col>
      </div>
    );
  });

  const DefaultContainer = ({ className, children }) => {
    return (
      <div style={{ color: "#fff" }}>
        <div className={className} style={{ display: "inline-grid" }}>
          <div className="datePicker border-bottom" style={{ width: "100%" }}>
            {children}
          </div>
        </div>
      </div>
    );
  };
  return (
    <DatePicker
      className={classnames("form-group form-control", className)}
      maxDate={new Date()}
      selectsRange={true}
      dateFormat="DD-MM-YYYY"
      startDate={startDate}
      endDate={endDate}
      monthsShown={2}
      customInput={customInput ? <CustomInput /> : null}
      onChange={onChange}
      shouldCloseOnSelect={!(!startDate || Boolean(startDate && endDate))}
      popperPlacement="bottom-end"
      calendarContainer={DefaultContainer}
      renderDayContents={renderDayContents ? renderDayContent : null}
    />
  );
};

export default BorderMultiSelect;
